import AnalyticsService from "@emcd-shared/analytics-service";

export default {
  createBroadcast:()=> {
    AnalyticsService.addBreadcrumb('StreamServiceCore.initPagesSteamsApi', {
      description: "Create broadcast channel",
    })
  },
  getPendingMessage:()=> {
    AnalyticsService.addBreadcrumb('StreamServiceCore.initPagesSteamsApi', {
      description: "Get broadcast hook: pending",
    })
  },
  getResolveMessage:()=> {
    AnalyticsService.addBreadcrumb('StreamServiceCore.initPagesSteamsApi', {
      description: "Get broadcast hook: resolve",
    })
  },
  getRejectMessage:()=> {
    AnalyticsService.addBreadcrumb('StreamServiceCore.initPagesSteamsApi', {
      description: "Get broadcast hook: reject",
    })
  },
  openStream:()=> {
    AnalyticsService.addBreadcrumb('StreamServiceCore.open', {
      description: "Open stream",
    })
  },
  closeStream:()=> {
    AnalyticsService.addBreadcrumb('StreamServiceCore.close', {
      description: "Close stream",
    })
  },
  sendBroadcastMessage:(status)=> {
    AnalyticsService.addBreadcrumb('StreamServiceCore.syncPagesSteams', {
      description: "Send message to pages",
      status
    })
  }
}